import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import NotificationsIcon from "@mui/icons-material/Notifications";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";
import { useUserDetails } from "../../../../context/auth";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSnackbar from "../../../../components/MaterialSnackbar";
import BASEURL from "../../../Utils/Baseurl";
import QuestionsAdd from "./questionsadd";
import {getallcourse} from '../../AssesmentCreation/mutation'

const AddAssessmentCreation = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    assesmentTitle: "",
    courseselection: "",
    assesmentcode: "",
    order: "",
    timelimit: "",
    passpercentage: "",
    passpercentageStatus: "unchecked",
    timelimitStatus: "unchecked",
    orderStatus: "unchecked",
    assesmentTitleStatus: "unchecked",
    courseselectionStatus: "unchecked",
    assesmentcodeStatus: "unchecked",
    fromDateStatus: "unchecked",
    toDateStatus: "unchecked",
  });
  const [Question, setQuestion] = useState({
    questiontype: "",
    questiontext: "",
    option1: "",
    option2: "",
    option3: "",
    option4: "",
    correctansweroption: "",
    markinput: "",
    questionlist: [],
  });

  const [courseoptionlist,setcourseoptionlist] =useState([])

    console.log("Question",Question)
  console.log("formData,",formData)
  const { circleLoading, setCirleLoading } = useLoading();

  const { display, setdisplay, AccessData, update, setupdate } =
    useUserDetails();

  const [id, setId] = useState(null);
  const [viewData, setViewData] = useState("");
  const [depdisplay, setdepdisplay] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });

  const [togglePage, setTogglePage] = useState({
    view: true,
    edit: true,
  });

  const [designationData, setDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "unchecked",
    designationNameStatus: "unchecked",
  });

  const [resource, setResource] = useState({
    departmentName: [],
  });

  const [originalDesigntionData, setOriginalDesignationData] = useState({
    departmentName: "",
    designationName: "",
    departmentNameStatus: "",
    designationNameStatus: "",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    onDepartmentSubmit();
    GetAllCourses()
    if (id) {
      getInitData(id);
    }
  }, []);

  useEffect(() => {
    onfilterData();
  }, [viewData]);

  const getInitData = async (id) => {
    const query = `query get_designation($id:String){
  getDesignationById(id:$id)
{
  id
  designation
  departmentName
}}

              `;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("responsesss:", response);
      // Extract Leavetype data from the response
      const departmentRowdata = response.data.data.getDesignationById;
      const departmentNameData =
        response.data.data.getDesignationById?.departmentName;
      setViewData(departmentNameData);
      setdepdisplay(true);
      setDesignationData({
        departmentName: {
          value: departmentRowdata.departmentName,
          label: departmentRowdata.departmentName,
        },
        designationName: departmentRowdata.designation,
        departmentNameStatus: departmentRowdata?.departmentName
          ? "success"
          : "unchecked",
        designationNameStatus: departmentRowdata.designation
          ? "success"
          : "unchecked",
      });

      setOriginalDesignationData({
        departmentName: {
          value: departmentRowdata.departmentName,
          label: departmentRowdata.departmentName,
        },
        designationName: departmentRowdata.designation,
      });

      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onEditDesignationSubmit = async () => {
    setCirleLoading(true);
    const query = `  mutation ($id: String!, $designation:String!, $departmentName: String!){
    EditDesignation(id:$id, designation:$designation, departmentName:$departmentName){
      designationeditdetails{
        designation
        departmentName
        id
      }
    }
  }
`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            designation: designationData.designationName,
            departmentName: designationData.departmentName.label,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Designation Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/designation");
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error Message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };
  console.log(designationData, "designationData");

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteDesignationSubmit();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteDesignationSubmit = async () => {
    const query = `
            mutation DeleteDesignation($id: String!) {
                deleteDesignation(id: $id) {
                    success
                    message
                }
            }
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteDesignation.success) {
        console.log("Designation deleted successfully!");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Designation deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/designation");
      } else {
        console.log(
          "Error deleting designation:",
          response.data.data.deleteDesignation.message
        );
      }
    } catch (error) {
      console.error("An error occurred while deleting the designation:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const onDepartmentSubmit = async () => {
    const query = `query {
            allDepartment {
                id
                departmentName
                departmentCode
            }
        }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      // Extract department data from the response
      const departmentListdata = response.data.data.allDepartment;
      setResource({
        ...resource,
        departmentName: departmentListdata,
      });
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response departmentListdata:", departmentListdata);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  const onDesignationSubmit = async () => {
    setCirleLoading(true);
    const query = `mutation Designations(
                $designation: String!
                 $departmentName: String!
              ) {
            AddComplaintForm(designation: $designation, departmentName: $departmentName) {
          designationdetails {
      id
      designation
      departmentName
      lastUpdate
            }
            }
           }`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            designation: designationData.designationName,
            departmentName: designationData.departmentName.label,
          },
        }),
      });

      console.log("response:", response.data);
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setCirleLoading(false);
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Designation Submitted Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/designation");
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

   const GetAllCourses = async () => {
      const query = getallcourse
  
      try {
        setPageState({ ...pageState, loading: true });
  
        const response = await axios.post(
          BASEURL,
          {
            query: query,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
  
        // Extract department data from the response
        const complaintList = response.data.data.allCourses;
        setcourseoptionlist(complaintList)
        setPageState({ ...pageState, loading: false, state: "success" });
  
        console.log("Response:", complaintList);
      } catch (error) {
        console.error("ResponseError:", error);
        setPageState({
          ...pageState,
          loading: false,
          error: true,
          message: error.message,
        });
      }
    };

  const handleDesignationDatachange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...formData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "department") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      if (selectEvent.name === "courseselection") {
        const lengthRegex = new RegExp("^.{1,100}$");
        if (lengthRegex.test(event?.label) === true) {
          formState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          formState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }

      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "assesmentTitle":
          {
            const alphaNLengthRegex = new RegExp("^.{1,50}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "assesmentcode":
          {
            const alphaNLengthRegex = new RegExp("^.{1,10}$");
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "fromDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "toDate":
          {
            const alphaNLengthRegex = new RegExp(
              "^[0-9]{4}-[0-9]{2}-[0-9]{2}$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "passpercentage":
          {
            const alphaNLengthRegex = new RegExp(
              "^([0-9]{1,3})$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
          case "timelimit":
          {
            const alphaNLengthRegex = new RegExp(
               "^([0-9]{1,3})$"
            );
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              formState[event.target.name + "Status"] = "success";
            } else {
              formState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setFormData(formState);
  };
  const onfilterData = () => {
    const filterDepartment = resource.departmentName.filter(
      (department) => department.departmentName == viewData
    );
    console.log(
      "filterDepartment:",
      viewData,
      resource.departmentName,
      filterDepartment
    );
    console.log("display:", display);
  };
  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDesignation();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onDiscardDesignation = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setDesignationData({
      departmentName: originalDesigntionData.departmentName,
      designationName: originalDesigntionData.designationName,
    });

    setupdate(false);
    setdepdisplay(true);
  };

  const handleAddComplaintForm = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDesignationSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
    setupdate(true);
    setdepdisplay(false);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      formData.passpercentageStatus === "success" &&
      formData.timelimitStatus === "success" &&
      formData.order != "" &&
      formData.assesmentTitleStatus === "success" &&
      formData.courseselectionStatus === "success" &&
      formData.assesmentcodeStatus === "success" &&
      formData.fromDateStatus === "success" &&
      formData.toDateStatus === "success" &&
      Question.questionlist?.length>0
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const checkFields = () => {
    let allowSubmit = false;
    if (
      designationData.departmentName ===
        originalDesigntionData.departmentName &&
      designationData.designationName === originalDesigntionData.designationName
    ) {
      allowSubmit = false;
    } else if (
      designationData.departmentName !== originalDesigntionData.departmentName
    ) {
      if (designationData.departmentNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else if (
      designationData.designationName !== originalDesigntionData.designationName
    ) {
      if (designationData.designationNameStatus === "success") {
        allowSubmit = true;
      } else {
        allowSubmit = false;
      }
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/designation");
  };

  const handleChangeradio = (e) => {
    setFormData({
      ...formData,
      order: e.target.value,
    });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "EditDesignation" && item.can_access
                ) &&
                (togglePage.edit || togglePage.view ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        {/* {togglePage.view
                          ? "View Designation Details"
                          : "Edit Designation Details"} */}
                          Assesment Creation
                      </MaterialTypography>
                    </Stack>

                    {display && (
                      <>
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          {/* Uncomment this block to add delete functionality */}

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      </>
                    )}
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                  >
                    <Stack direction="column" spacing={0}>
                      <MaterialTypography variant="h5" fontWeight="medium">
                        Add Designation Details
                      </MaterialTypography>
                    </Stack>
                  </Stack>
                ))}
            </>
          }
        />

        <CardContent sx={{ minHeight: "55vh" }}>
          <MaterialBox>
            <Grid container spacing={1}>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Assessment Title <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="assesmentTitle"
                  value={formData.assesmentTitle}
                  onChange={handleDesignationDatachange}
                  error={formData.assesmentTitleStatus === "error"}
                  success={formData.assesmentTitleStatus === "success"}
                />
                {formData.assesmentTitleStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                     Assesment Time should be a maximum of 50 characters long
                      and can contain only alphabets.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Assessment Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="assesmentcode"
                  value={formData.assesmentcode}
                  onChange={handleDesignationDatachange}
                  error={formData.assesmentcodeStatus === "error"}
                  success={formData.assesmentcodeStatus === "success"}
                />
                {formData.assesmentcodeStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Assessment Code should be a maximum of 10 characters long
                      and can contain only variables characters.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Course <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="courseselection"
                  value={formData.courseselection}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleDesignationDatachange} //selectedValue, event
                    options={courseoptionlist.map((value) => {
                      return {
                        value: value.id,
                        label: value.title,
                      };
                    })}
                  error={
                    formData.courseselectionStatus === "error" ? true : false
                  }
                  success={
                    formData.courseselectionStatus === "success" ? true : false
                  }
                  // isClearable
                  isDisabled={depdisplay}
                />
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Start Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="fromDate"
                  type="date"
                  value={formData.fromDate}
                  onChange={handleDesignationDatachange}
                  error={formData.fromDateStatus === "error"}
                  success={formData.fromDateStatus === "success"}
                />
                {formData.fromDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                     Please enter Start Date and selected date sholud be less than end date
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    End Date<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="toDate"
                  type="date"
                  value={formData.toDate}
                  onChange={handleDesignationDatachange}
                  error={formData.toDateStatus === "error"}
                  success={formData.toDateStatus === "success"}
                />
                {formData.toDateStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Please enter End Date
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Time Limit <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="timelimit"
                  value={formData.timelimit}
                  onChange={handleDesignationDatachange}
                  error={formData.timelimitStatus  === "error"}
                  success={formData.timelimitStatus === "success"}
                />
                {formData.timelimitStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                      Time Limit should be a maximum of 3 characters long
                      and can contain only digits.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
             <Grid size={{ xs: 5, sm: 4 }}>
             <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Question order <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
            </MaterialBox>
              <RadioGroup
                sx={{marginLeft:'2%'}}
                row
                name="correctansweroption"
                value={formData.order}
                onChange={handleChangeradio}
              >
                {["Same", "Random"].map((val, idx) => (
                  <FormControlLabel
                    key={idx}
                    value={`option${idx + 1}`}
                    control={<Radio />}
                    label={val}
                  />
                ))}
              </RadioGroup>
              </Grid>
              <Grid size={{ xs: 5, sm: 4 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Pass Percentage <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="passpercentage"
                  value={formData.passpercentage}
                  onChange={handleDesignationDatachange}
                  error={formData.passpercentageStatus=== "error"}
                  success={formData.passpercentageStatus === "success"}
                />
                {formData.passpercentageStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>
                    Pass Percentage should be a maximum of 3 characters long
                    and can contain only digits.
                    </FormHelperText>
                  </FormControl>
                )}
              </Grid>
            </Grid>
          </MaterialBox>
          <div>
            <QuestionsAdd question={Question} setQuestion={setQuestion} />
          </div>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {update && (
            <>
              <MaterialButton
                variant="gradient"
                color="dark"
                onClick={AddDiscard}
              >
                Discard
              </MaterialButton>

              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkFields()}
                onClick={onEditDesignationSubmit}
              >
                Update
              </MaterialButton>
            </>
          )}

          {!display && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handlecancel}
              >
                Cancel
              </MaterialButton>
              <MaterialButton
                sx={{ m: 4, marginLeft: "4px" }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleAddComplaintForm}
              >
                Submit
              </MaterialButton>
            </>
          )}
        </MaterialBox>
        {
          <MaterialSnackbar
            color="success"
            icon={<NotificationsIcon />}
            title="Message"
            content="You have been submitted successfully"
            open={snackBar.Success}
            close={() =>
              setSnackBar({
                success: false,
              })
            }
          />
        }
      </Card>
    </DashboardLayout>
  );
};

export default AddAssessmentCreation;
